import React from "react";

type IconProps = React.SVGProps<SVGSVGElement>;

const KcsIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.16699 7.25326C5.57928 7.25335 5.91373 7.58768 5.91373 8C5.91373 8.41232 5.57928 8.74666 5.16699 8.74675C4.75461 8.74675 4.42024 8.41237 4.42024 8C4.42024 7.58763 4.75461 7.25326 5.16699 7.25326Z"
        fill="#595959"
      />
      <path
        d="M8.00032 7.25326C8.41261 7.25335 8.74706 7.58768 8.74706 8C8.74706 8.41232 8.41262 8.74666 8.00032 8.74675C7.58795 8.74675 7.25358 8.41237 7.25358 8C7.25358 7.58763 7.58795 7.25326 8.00032 7.25326Z"
        fill="#595959"
      />
      <path
        d="M10.8337 7.25326C11.2459 7.25335 11.5804 7.58768 11.5804 8C11.5804 8.41232 11.2459 8.74666 10.8337 8.74675C10.4213 8.74675 10.0869 8.41237 10.0869 8C10.0869 7.58763 10.4213 7.25326 10.8337 7.25326Z"
        fill="#595959"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.01009 1.30664C12.0418 1.30859 15.24 4.88766 14.6071 9.03971C14.1938 11.7664 12.0532 13.9865 9.35318 14.5332C8.89328 14.6198 8.44674 14.6667 8.00683 14.6667C6.96688 14.6667 5.99357 14.42 5.1136 14H2.64029C2.27363 14 1.97363 13.7 1.97363 13.3333V10.8333C1.38696 9.58667 1.16029 8.13995 1.47363 6.61328C2.02697 3.92677 4.25331 1.80016 6.96647 1.38672C7.31866 1.33356 7.66454 1.30681 8.01009 1.30664ZM8.01985 2.63997C7.73996 2.63999 7.45338 2.6664 7.1735 2.70638C5.02683 3.03305 3.22678 4.75339 2.78678 6.88672C2.54679 8.04004 2.68652 9.20694 3.18652 10.2669C3.26649 10.4402 3.31347 10.6334 3.31347 10.8333V12.6667H5.12011C5.32011 12.6667 5.52019 12.7135 5.70019 12.8001C6.43346 13.1534 7.21342 13.3333 8.01334 13.3333C8.36667 13.3333 8.73342 13.2999 9.09342 13.2266C11.2401 12.7932 12.9666 10.9865 13.2933 8.83984C13.5399 7.24656 13.1065 5.70647 12.0732 4.50651C11.117 3.39415 9.75662 2.72685 8.30501 2.64779L8.01985 2.63997Z"
        fill="#595959"
      />
    </svg>
  );
};

export default KcsIcon;
